import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_ParticipantTermination_ParticipantTerminationDetailDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { ModalStatusType } from '../../types/common';

const useGetParticipantTerminationFromCustomer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string,
  modalStatus?: ModalStatusType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_ParticipantTermination_ParticipantTerminationDetailDto | undefined,
  unknown
> => {
  const participantTermination = useQuery(
    ['getParticipantTerminationFromCustomer', id, modalStatus],
    async () => {
      if (id.length > 0 && modalStatus === 'Termination Details') {
        return await handleRequest(
          ParticipantService.getApiCustomerApiAppParticipantParticipantTermination(id)
        );
      }
    },
    {
      enabled: id.length > 0 && modalStatus === 'Termination Details',
    }
  );

  return participantTermination;
};

export default useGetParticipantTerminationFromCustomer;
